import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { CityService } from "../core/service/city.service";
import { City } from "../core/model/city";

@Component({
  selector: "app-city",
  templateUrl: "./city.component.html",
  styleUrls: ["./city.component.scss"],
})
export class CityComponent {
  cities: City[];

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _cityService: CityService
  ) {}

  ngOnInit() {
    this.getCities();
  }

  getCities() {
    this._cityService.getAllCities().subscribe(
      (data) => {
        this.cities = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  add(): void {
    this._router.navigate(["/parametrage/city/add-city"]);
  }
}
